/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin.js';
import {SplitText} from 'gsap/SplitText.js';
import {_numWithUnitExp} from 'gsap/gsap-core';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin.js';

( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      gsap.registerPlugin( DrawSVGPlugin );
      gsap.registerPlugin( SplitText );
      gsap.registerPlugin( ScrollToPlugin );


      // LOGO SECTION DRAW AND SPIN
      const sectionLogo = document.querySelectorAll( '.epik-logo' );

      sectionLogo.forEach( ( section, idx ) => {
        const logo = section.querySelector( '.epik-gold' );
        const gold = logo.querySelectorAll( '.cls-1' );
        const letters = logo.querySelectorAll( '.cls-2' );
        const tl = gsap.timeline( {
          paused: true,
        } );

        tl.to( gold, {
          drawSVG: '100%',
          duration: 2,
          ease: 'power4.inOut',
        } ).to( gold, {
          fill: '#d7be67',
          duration: 1,
          delay: -1,
        } ).to( letters, {
          drawSVG: '100%',
          duration: 1,
          stagger: 0.1,
          ease: 'power4.inOut',
          delay: -1,
        } ).to( letters, {
          fill: '#FEFEFE',
          duration: 1,
          delay: -0.5,
        } );

        tl.play();

        gsap.to( logo, {
          rotate: -70,
          y: -window.innerHeight / 8,
          transformOrigin: 'center',
          scrollTrigger: {
            trigger: section,
            start: 'bottom 100%',
            end: 'bottom top',
            scrub: true,
          },
        } );

        const borderSVG = document.querySelectorAll( '.border_svg' );
        if ( borderSVG ) {
          borderSVG.forEach( ( b, idx ) => {
            const top = b.querySelector( '.top' );
            const right = b.querySelector( '.right' );
            const bottom = b.querySelector( '.bottom' );
            const left = b.querySelector( '.left' );

            const tl = gsap.timeline( {
              scrollTrigger: {
                trigger: this,
                start: 'top 90%',
                scrub: false,
              },
            } );

            tl.from( left, {
              drawSVG: 0,
              duration: 1.5,
              ease: 'power4.inOut',
            } ).from( top, {
              drawSVG: 0,
              duration: 1.5,
              ease: 'power4.inOut',
            } ).from( right, {
              drawSVG: 0,
              duration: 1.5,
              ease: 'power4.inOut',
              delay: -3,
            } ).from( bottom, {
              drawSVG: 0,
              duration: 1.5,
              ease: 'power4.inOut',
            } );
          } );
        }
      } );

      // section-2
      // Grabbing text and text reflection elements
      const text = document.querySelector( '.two .animate_text' );
      const reflection = document.querySelector( '.two .reflection' );

      // Creating the option to split elements between words or characters
      const splitText = new SplitText( text, {type: 'words, chars'} );
      const reflectionSplit = new SplitText( reflection, {type: 'words, chars'} );

      // Timeline for Regular Text
      const animTL = gsap.timeline( {
        trigger: '#section-2',
        pin: true,
        start: 'top top',
        scrub: 1,
      } );

      // Timeline for Reflection
      const reflectionTL = gsap.timeline();


      // If the reflection option is turned on, apply the same animation to the reflection (see footnote I)
      if ( reflection ) {
        reflectionTL.fromTo( reflectionSplit.chars, {
          y: -25,
          color: 'black',
          opacity: 0,
          duration: 0.75,
          stagger: 0.05,
          ease: 'power3.inOut',
        },
        {
          color: 'white',
          y: 0,
          opacity: 1,
          duration: 0.75,
          stagger: 0.05,
          ease: 'power3.inOut',
        } );
      }

      // letter-slide-in-down
      animTL.fromTo( splitText.chars, {
        y: -25,
        color: 'black',
        opacity: 0,
        duration: 0.75,
        stagger: 0.05,
        ease: 'power3.inOut',
      },
      {
        color: 'white',
        y: 0,
        opacity: 1,
        duration: 0.75,
        stagger: 0.05,
        ease: 'power3.inOut',
      } );

      ScrollTrigger.create( {
        animation: reflectionTL,
        trigger: '#section-2',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',
        end: 'top bottom',
      } );

      ScrollTrigger.create( {
        animation: animTL,
        trigger: '#section-2',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',
        end: 'top bottom',
      } );

      // section-3
      const section = document.querySelector( '.three' );
      const wysiwyg = section.querySelector( '.wysiwyg' );
      const splitWysiwyg = new SplitText( wysiwyg, {type: 'lines, words, chars'} );
      const wLines = splitWysiwyg.lines;
      const sectionThree = gsap.timeline();

      wLines.forEach( ( line, idx ) => {
        line.classList.add( 'line' );
        const splitLine = new SplitText( line, {type: 'words'} );
        const words = splitLine.words;

        sectionThree.to( $( '.three .line' ), {
          y: '0',
          opacity: 1,
          ease: 'power3.inOut',
          duration: 1,
          color: 'white',
        } );
      } );

      ScrollTrigger.create( {
        animation: sectionThree,
        trigger: '#section-3',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      // #section-4
      const sectionFour = document.querySelector( '.four' );
      const wysiwygFour = sectionFour.querySelector( '.wysiwyg' );
      const splitWysiwygFour = new SplitText( wysiwygFour, {type: 'lines, words, chars'} );
      const wLinesFour = splitWysiwygFour.lines;
      const sectionFourAnim = gsap.timeline();

      wLinesFour.forEach( ( line, idx ) => {
        line.classList.add( 'line' );
        const splitLine = new SplitText( line, {type: 'words'} );
        const words = splitLine.words;

        sectionFourAnim.to( $( '.four .line' ), {
          y: '0',
          opacity: 1,
          ease: 'power3.inOut',
          color: 'white',
          duration: 1,
        } );
      } );

      ScrollTrigger.create( {
        animation: sectionFourAnim,
        trigger: '#section-4',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      // #section-5

      const sectionFive = document.querySelector( '#section-5' );
      const wysiwygFive = sectionFive.querySelector( '.wysiwyg' );
      const splitWysiwygFive = new SplitText( wysiwygFive, {type: 'lines, words, chars'} );
      const wLinesFive = splitWysiwygFive.lines;
      const fiveAnimate = gsap.timeline();

      wLinesFive.forEach( ( line, idx ) => {
        line.classList.add( 'line' );
        const splitLine = new SplitText( line, {type: 'words'} );

        fiveAnimate.to( $( '#section-5 .line' ), {
          y: '0',
          opacity: 1,
          ease: 'power3.inOut',
          color: 'white',
          duration: 1,
        } );
      } );

      ScrollTrigger.create( {
        animation: fiveAnimate,
        trigger: '#section-5',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      // section-6

      const sectionSix = document.querySelector( '.six.full-screen-image-content' );

      const image = sectionSix.querySelector( '.image' );
      const heading = sectionSix.querySelector( '.heading' );
      const description = sectionSix.querySelector( '.description' );
      const splitHeading = new SplitText( heading, {type: 'lines'} );
      const splitDescription = new SplitText( description, {type: 'lines'} );
      const hdgChars = splitHeading.lines;
      const hdgLines = splitHeading.lines;
      const contentLines = splitDescription.lines;
      const sectionSixAnimation = gsap.timeline();

      hdgChars.forEach( ( line, idx ) => {
        line.classList.add( 'line' );
      } );

      contentLines.forEach( ( line, idx ) => {
        line.classList.add( 'line' );
      } );

      sectionSixAnimation.to( image, {scale: 1, opacity: 1, duration: 2, ease: 'power3.inOut'} )
          .to( hdgChars, {y: 0, opacity: 1, duration: 1, stagger: 0.05, delay: -0.5} )
          .to( contentLines, {y: 0, opacity: 1, duration: 1, stagger: 0.1, delay: -0.25} );

      ScrollTrigger.create( {
        animation: sectionSixAnimation,
        trigger: '#section-6',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      // section-7

      const sectionSeven = document.querySelector( '.seven.icon-rows' );

      let animTrigger = false;
      const headingSeven = sectionSeven.querySelector( '.heading' );
      const columns = sectionSeven.querySelectorAll( '.icon_col' );

      const splitHeadingSeven = new SplitText( headingSeven, {type: 'lines, words'} );
      const hdgLinesSeven = splitHeadingSeven.lines;
      const hdgSplit = splitHeadingSeven.words;
      const colSVGs = sectionSeven.querySelectorAll( '.icon_col svg' );
      const colContent = sectionSeven.querySelectorAll( '.icon_col .content' );
      const sectionSevenAnim = gsap.timeline();

      hdgLinesSeven.forEach( ( hl, idx ) => {
        hl.classList.add( 'line' );
      } );

      if ( window.innerWidth > 767 ) {
        const sectionSevenAnim = gsap.timeline( {
          scrollTrigger: {
            trigger: sectionSeven,
            start: 'top bottom',
            pin: false,
            onUpdate: ( self ) => {
              animTrigger = true;

              gsap.to( headingSeven, {
                y: 0,
                opacity: 1,
                color: 'white',
                duration: 1,
                ease: 'power3.inOut',
                stagger: 0.1,
              } );

              gsap.to( hdgSplit, {
                y: 0,
                opacity: 1,
                duration: 1,
                ease: 'power3.inOut',
                stagger: 0.1,
              } );

              gsap.to( colSVGs, {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: 'power4.inOut',
                stagger: 0.1,
              } );

              gsap.to( colContent, {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: 'power4.inOut',
                stagger: 0.1,
              } );
            },
          },
        } );
      } else {
        gsap.to( hdgSplit, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.inOut',
          stagger: 0.1,
          scrollTrigger: {
            trigger: sectionSeven,
            start: '55% bottom',
          },
        } );

        gsap.to( colSVGs, {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power4.inOut',
          stagger: 0.25,
          scrollTrigger: {
            trigger: sectionSeven,
            start: '55% bottom',
          },
        } );

        gsap.to( colContent, {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power4.inOut',
          stagger: 0.25,
          scrollTrigger: {
            trigger: sectionSeven,
            start: '55% bottom',
          },
        } );
      }

      columns.forEach( ( col, idx ) => {
        const paths = col.querySelectorAll( 'svg path' );
        const tl = gsap.timeline( {repeat: -1, repeatDelay: 1} );

        tl.to( paths, {
          fill: 'transparent',
          duration: 1,
        } );

        tl.to( paths, {
          drawSVG: '0%',
          duration: 1,
          stagger: 0.1,
        } );

        tl.to( paths, {
          drawSVG: '100%',
          duration: 1,
          stagger: 0.1,
        } );

        tl.to( paths, {
          fill: '#D7BE67',
          duration: 0.5,
          delay: -0.5,
        } );
      } );

      ScrollTrigger.create( {
        animation: sectionSevenAnim,
        trigger: '#section-7',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      // SECTION EIGHT

      const sectionEight = document.querySelector( '.eight.quadrant-graph' );
      let tlControl = false;

      const headingEight = sectionEight.querySelector( '.heading' );
      const vLine = sectionEight.querySelector( '.vertical_split' );
      const hLine = sectionEight.querySelector( '.horizontal_split' );
      const images = sectionEight.querySelectorAll( '.image .fit-image' );
      const content = sectionEight.querySelectorAll( '.wysiwyg > *' );
      const eightAnimate = gsap.timeline();

      // Heading Split Text
      const splitHeadingEight = new SplitText( headingEight, {type: 'lines, words'} );
      const hdgLinesEight = splitHeadingEight.lines;
      const hdgWords = splitHeadingEight.words;

      hdgLinesEight.forEach( ( hl, idx ) => {
        hl.classList.add( 'line' );
      } );

      // animation timeline for scrolltrigger control
      eightAnimate.to( vLine, {scaleY: 1, duration: 2, ease: 'power4.inOut'} )
          .to( hLine, {scaleX: 1, duration: 2, ease: 'power4.inOut', delay: -1.5} )
          .to( images, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.inOut', stagger: 0.25, delay: -1.5} )
          .to( content, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.inOut', stagger: 0.25, delay: -2} )
          .to( headingEight, {
            y: 0,
            opacity: 1,
            color: 'white',
            duration: 1,
            ease: 'power3.inOut',
            stagger: 0.1,
            delay: -2,
          } );

      // Timeline Control, play Desktop Timeline when on tablet or greater, otherwise, run simple animations for mobile
      if ( window.innerWidth > 767 ) {
        // Pin section, control duration with the number on line 62
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: sectionEight,
            start: 'top top',
            pin: false,
            pinSpacing: true,
            scrub: 1,
            onUpdate: ( self ) => {
              tlControl = true;
              gsap.to( hdgWords, {y: 0, opacity: 1, duration: 1, ease: 'power3.inOut', stagger: 0.1} );
            },
          },
        } );
      } else {
        const tlMB = gsap.timeline( {
          scrollTrigger: {
            trigger: section,
            start: 'top 50%',
          },
        } );

        tlMB.to( hdgWords, {y: 0, opacity: 1, duration: 1, ease: 'power3.inOut', stagger: 0.1} )
            .to( vLine, {scaleY: 1, duration: 2, ease: 'power4.inOut', delay: -1} )
            .to( images, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.inOut', stagger: 0.25, delay: -1.5} )
            .to( content, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.inOut', stagger: 0.25, delay: -2} );
      }

      ScrollTrigger.create( {
        animation: eightAnimate,
        trigger: '#section-8',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      // section nine

      const sectionNine = document.querySelector( '.nine' );
      const nineAnim = gsap.timeline();

      nineAnim.to( $( '.nine .line' ), {
        y: '0',
        opacity: 1,
        ease: 'power3.inOut',
        duration: 1,
        color: 'white',
        stagger: 0.75,
      } );

      ScrollTrigger.create( {
        animation: nineAnim,
        trigger: '#section-9',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      // section ten

      const sectionTen = document.querySelector( '.ten.small-card-grid' );

      const headingTen = sectionTen.querySelector( '.heading' );
      const contentTen = sectionTen.querySelectorAll( '.content' );

      // Heading Split Text
      const splitHeadingTen = new SplitText( headingTen, {type: 'lines, words'} );
      const hdgLinesTen = splitHeadingTen.lines;
      const hdgWordsTen = splitHeadingTen.words;

      hdgLinesTen.forEach( ( hl, idx ) => {
        hl.classList.add( 'line' );
      } );

      const tenAnimation = gsap.timeline();

      tenAnimation.to( hdgWordsTen, {y: 0, opacity: 1, duration: 1, ease: 'power3.inOut', stagger: 0.1} )
          .to( contentTen, {y: 0, opacity: 1, duration: 2, ease: 'power4.inOut', stagger: 0.1, delay: -2} )
          .to( headingTen, {
            y: 0,
            opacity: 1,
            color: 'white',
            duration: 1,
            ease: 'power3.inOut',
            stagger: 0.1,
            delay: -1.5,
          } );

      if ( window.innerWidth > 767 ) {
      // Pin sectionTen, control duration with the number on line 62
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: sectionTen,
            start: 'top top',
            pin: false,
            // anticipatePin: true,
            pinSpacing: true,
            scrub: 1,
          },
        } );
      } else {
        gsap.to( hdgWords, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.inOut',
          stagger: 0.1,
          scrollTrigger: {
            trigger: sectionTen,
            start: 'top 50%',
          },
        } );

        content.forEach( ( card, idx ) => {
          gsap.to( card, {
            y: 0,
            opacity: 1,
            duration: 1,
            ease: 'power4.inOut',
            scrollTrigger: {
              trigger: card,
              start: 'top 90%',
            },
          } );
        } );
      }

      ScrollTrigger.create( {
        animation: tenAnimation,
        trigger: '#section-10',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      // SECTION ELEVEN

      const sectionEleven = document.querySelector( '.eleven.word-slide-down' );

      const elevenAnim = gsap.timeline();
      const wysiwygEleven = sectionEleven.querySelector( '.wysiwyg' );

      const splitWysiwygEleven = new SplitText( wysiwygEleven, {type: 'lines, words, chars'} );
      const wWords = splitWysiwygEleven.words;

      elevenAnim.fromTo( wWords,
          {
            y: '-100%',
            duration: 1,
            ease: 'power3.inOut',
            stagger: 0.075,
            color: 'black',
          },
          {
            y: '0',
            duration: 1,
            ease: 'power3.inOut',
            stagger: 0.075,
            color: 'white',
          } );

      if ( window.innerWidth > 767 ) {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: sectionEleven,
            start: 'top 65%',
            end: 'bottom center',
            scrub: true,
            toggleActions: 'play pause resume pause',
          },
        } );
      } else {
        gsap.to( wysiwygEleven, {
          y: 0,
          opacity: 1,
          duration: 2,
          ease: 'power4.inOut',
          scrollTrigger: {
            trigger: sectionEleven,
            start: 'top 75%',
          },
        } );
      }

      ScrollTrigger.create( {
        animation: elevenAnim,
        trigger: '#section-11',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      // SECTION TWELVE

      const sectionTwelve = document.querySelector( '.twelve.long-content' );

      const headingTwelve = sectionTwelve.querySelector( '.heading' );
      const contentTwelve = sectionTwelve.querySelectorAll( '.wysiwyg *:not(b, strong)' );

      // Heading Split Text
      const splitHeadingTwelve = new SplitText( headingTwelve, {type: 'lines, words'} );
      const hdgLinesTwelve = splitHeadingTwelve.lines;
      const hdgWordsTwelve = splitHeadingTwelve.words;

      hdgLinesTwelve.forEach( ( hl, idx ) => {
        hl.classList.add( 'line' );
      } );

      const twelveAnim = gsap.timeline();

      twelveAnim.to( hdgWordsTwelve, {y: 0, opacity: 1, duration: 1, ease: 'power3.inOut', stagger: 0.1} )
          .to( contentTwelve, {y: 0, opacity: 1, duration: 2, ease: 'power4.inOut', stagger: 0.1, delay: -1} )
          .to( headingTen, {
            y: 0,
            opacity: 1,
            color: 'white',
            duration: 1,
            ease: 'power3.inOut',
            stagger: 0.1,
            delay: -0.15,
          } );

      if ( window.innerWidth > 767 ) {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: sectionTwelve,
            start: 'top top',
            pin: false,
            pinSpacing: true,
            scrub: 1,
          },
        } );
      } else {
        gsap.to( hdgWordsTwelve, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.inOut',
          stagger: 0.1,
          scrollTrigger: {
            trigger: sectionTwelve,
            start: 'top top',
          },
        } );

        content.forEach( ( card, idx ) => {
          gsap.to( card, {
            y: 0,
            opacity: 1,
            duration: 2,
            ease: 'power4.inOut',
            scrollTrigger: {
              trigger: card,
              start: 'top top',
            },
          } );
        } );
      }

      ScrollTrigger.create( {
        animation: twelveAnim,
        trigger: '#section-12',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      // section thirteen

      // Grabbing text and text reflection elements
      const textThirteen = document.querySelector( '.thirteen .animate_text' );
      const reflectionThirteen = document.querySelector( '.thirteen .reflection' );

      // Creating the option to split elements between words or characters
      const splitTextThirteen = new SplitText( textThirteen, {type: 'words, chars'} );
      const reflectionSplitThirteen = new SplitText( reflectionThirteen, {type: 'words, chars'} );

      // Timeline for Regular Text
      const animTLThirteen = gsap.timeline();

      // Timeline for Reflection
      const reflectionTLThirteen = gsap.timeline();

      // If the reflection option is turned on, apply the same animation to the reflection (see footnote I)
      if ( reflectionThirteen ) {
        reflectionTLThirteen.fromTo( reflectionSplitThirteen.chars, {
          y: 25,
          color: 'black',
          opacity: 0,
          duration: 0.75,
          stagger: 0.05,
          ease: 'power3.inOut',
        },
        {
          color: 'white',
          y: 0,
          opacity: 1,
          duration: 0.75,
          stagger: 0.05,
          ease: 'power3.inOut',
        } );
      }

      // letter-slide-in-down
      animTLThirteen.fromTo( splitTextThirteen.chars, {
        y: 25,
        color: 'black',
        opacity: 0,
        duration: 0.75,
        stagger: 0.05,
        ease: 'power3.inOut',
      },
      {
        color: 'white',
        y: 0,
        opacity: 1,
        duration: 0.75,
        stagger: 0.05,
        ease: 'power3.inOut',
      } );

      ScrollTrigger.create( {
        animation: reflectionTLThirteen,
        trigger: '#section-13',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      ScrollTrigger.create( {
        animation: animTLThirteen,
        trigger: '#section-13',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      // FOURTEEN

      const sectionFourteen = document.querySelector( '.fourteen.team-grid' );

      const headingFourteen = sectionFourteen.querySelector( '.heading' );
      const imagesFourteen = sectionFourteen.querySelectorAll( '.team_image' );


      // Heading Split Text
      const splitHeadingFourteen = new SplitText( headingFourteen, {type: 'lines, words'} );
      const hdgLinesFourteen = splitHeadingFourteen.lines;
      const hdgWordsFourteen = splitHeadingFourteen.words;

      hdgLinesFourteen.forEach( ( hl, idx ) => {
        hl.classList.add( 'line' );
      } );

      const fourteenAnim = gsap.timeline();

      fourteenAnim.fromTo( hdgWordsFourteen, {y: -100, opacity: 0, duration: 1, ease: 'power3.inOut', stagger: 0.1}, {color: 'white', y: 0, opacity: 1, duration: 1, ease: 'power3.inOut', stagger: 0.1} )
          .to( imagesFourteen, {y: 0, opacity: 1, duration: 2, ease: 'power4.inOut', stagger: 0.1, delay: -1.5} );

      if ( window.innerWidth > 767 ) {
        // Pin sectionFourteen, control duration with the number on line 62
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: sectionFourteen,
            start: 'top top',
            pin: false,
            // anticipatePin: true,
            pinSpacing: true,
            scrub: 1,
            toggleActions: 'Restart pause reverse pause',
          },
        } );
      } else {
        gsap.to( hdgWordsFourteen, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.inOut',
          stagger: 0.1,
          scrollTrigger: {
            trigger: sectionFourteen,
            start: 'top 50%',
          },
        } );

        images.forEach( ( img, idx ) => {
          gsap.to( img, {
            y: 0,
            opacity: 1,
            duration: 1,
            ease: 'power4.inOut',
            scrollTrigger: {
              trigger: img,
              start: 'top 90%',
            },
          } );
        } );
      }

      ScrollTrigger.create( {
        animation: fourteenAnim,
        trigger: '#section-14',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      // FIFTEEN

      const sectionFifteen = document.querySelector( '.fifteen.standard-left-right' );
      const headingFifteen = sectionFifteen.querySelector( '.heading' );
      const contentFifteen = sectionFifteen.querySelectorAll( '.wysiwyg *:not(b, strong)' );
      const imageFifteen = sectionFifteen.querySelector( '.fit-image' );

      // Heading Split Text
      const splitHeadingFifteen = new SplitText( headingFifteen, {type: 'lines, words'} );
      const hdgLinesFifteen = splitHeadingFifteen.lines;
      const hdgWordsFifteen = splitHeadingFifteen.words;

      hdgLinesFifteen.forEach( ( hl, idx ) => {
        hl.classList.add( 'line' );
      } );

      const fifteenAnim = gsap.timeline();

      fifteenAnim.fromTo( hdgWordsFifteen, {y: -100, opacity: 0, color: 'black'}, {color: 'white', y: 0, opacity: 1, duration: 1, ease: 'power3.inOut', stagger: 0.1} )
          .to( contentFifteen, {y: 0, opacity: 1, duration: 2, ease: 'power4.inOut', stagger: 0.1, delay: -1.25} )
          .to( imageFifteen, {y: 0, opacity: 1, duration: 2, ease: 'power4.inOut', stagger: 0.1, delay: -2.25} );

      if ( window.innerWidth > 767 ) {
        // Pin sectionFifteen, control duration with the number on line 62
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: sectionFifteen,
            start: 'top top',
            pin: false,
            pinSpacing: true,
            scrub: 1,
          },
        } );
      } else {
        gsap.to( hdgWordsFifteen, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.inOut',
          stagger: 0.1,
          scrollTrigger: {
            trigger: sectionFifteen,
            start: 'top 25%',
          },
        } );

        gsap.to( contentFifteen, {
          y: 0,
          opacity: 1,
          duration: 2,
          ease: 'power3.inOut',
          stagger: 0.1,
          scrollTrigger: {
            trigger: sectionFifteen,
            start: 'top top',
          },
        } );

        gsap.to( imageFifteen, {
          y: 0,
          opacity: 1,
          duration: 2,
          ease: 'power3.inOut',
          stagger: 0.1,
          scrollTrigger: {
            trigger: sectionFifteen,
            start: 'top 75%',
          },
        } );
      }

      ScrollTrigger.create( {
        animation: fifteenAnim,
        trigger: '#section-15',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      // SIXTEEN

      const sectionSixteen = document.querySelector( '.sixteen.content-cards' );

      const headingSixteen = sectionSixteen.querySelector( '.heading' );
      const contentSixteen = sectionSixteen.querySelectorAll( '.content' );

      // Heading Split Text
      const splitHeadingSixteen = new SplitText( headingSixteen, {type: 'lines, words'} );
      const hdgLinesSixteen = splitHeadingSixteen.lines;
      const hdgWordsSixteen = splitHeadingSixteen.words;

      hdgLinesSixteen.forEach( ( hl, idx ) => {
        hl.classList.add( 'line' );
      } );

      const sixteenAnim = gsap.timeline();

      sixteenAnim.fromTo( hdgWordsSixteen, {y: -100, opacity: 0, color: 'black'}, {color: 'white', y: 0, opacity: 1, duration: 1, ease: 'power3.inOut', stagger: 0.1} )
          .to( contentSixteen, {y: 0, opacity: 1, duration: 2, ease: 'power4.inOut', stagger: 0.1, delay: -1.25} );

      if ( window.innerWidth > 767 ) {
        // Pin sectionSixteen, control duration with the number on line 62
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: sectionSixteen,
            start: 'top top',
            pin: false,
            pinSpacing: true,
            scrub: 1,
          },
        } );
      } else {
        gsap.to( hdgWordsSixteen, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.inOut',
          stagger: 0.1,
          scrollTrigger: {
            trigger: sectionSixteen,
            start: 'top 50%',
          },
        } );

        content.forEach( ( card, idx ) => {
          gsap.to( card, {
            y: 0,
            opacity: 1,
            duration: 2,
            ease: 'power4.inOut',
            scrollTrigger: {
              trigger: card,
              start: 'top 100%',
            },
          } );
        } );
      }

      ScrollTrigger.create( {
        animation: sixteenAnim,
        trigger: '#section-16',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      // SEVENTEEN

      const sectionSeventeen = document.querySelector( '.seventeen.one-column-wysiwyg' );
      const wysiwygSeventeen = sectionSeventeen.querySelector( '.wysiwyg' );
      const splitWysiwygSeventeen = new SplitText( wysiwygSeventeen, {type: 'lines, words, chars'} );
      const wLinesSeventeen = splitWysiwygSeventeen.lines;
      const seventeenAnim = gsap.timeline();

      wLinesSeventeen.forEach( ( line, idx ) => {
        line.classList.add( 'line' );
        const splitLine = new SplitText( line, {type: 'words'} );
        const words = splitLine.words;

        seventeenAnim.to( $( '.seventeen .line' ), {
          y: '0',
          opacity: 1,
          ease: 'power3.inOut',
          color: 'white',
          duration: 0.5,
        } );
      } );

      ScrollTrigger.create( {
        animation: seventeenAnim,
        trigger: '#section-17',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      // EIGHTEEN

      const sectionEighteen = document.querySelector( '.eighteen.logo-content' );

      const headingEighteen = sectionEighteen.querySelector( '.heading' );
      const contentEighteen = sectionEighteen.querySelectorAll( '.wysiwyg *:not(b, strong)' );

      // Logo Variables
      const logo = sectionEighteen.querySelector( '.epik-gold' );
      const gold = logo.querySelectorAll( '.cls-1' );
      const letters = logo.querySelectorAll( '.cls-2' );

      // Heading Split Text
      const splitHeadingEighteen = new SplitText( headingEighteen, {type: 'lines, words'} );
      const hdgLinesEighteen = splitHeadingEighteen.lines;
      const hdgWordsEighteen = splitHeadingEighteen.words;

      hdgLinesEighteen.forEach( ( hl, idx ) => {
        hl.classList.add( 'line' );
      } );

      const eighteenAnim = gsap.timeline();

      eighteenAnim.to( hdgWordsEighteen, {y: 0, opacity: 1, duration: 1, ease: 'power3.inOut', stagger: 0.1} )
          .to( contentEighteen, {y: 0, opacity: 1, duration: 2, ease: 'power4.inOut', stagger: 0.1, delay: -1.25} )
          .to( gold, {drawSVG: '100%', duration: 2, ease: 'power4.inOut', delay: -3} )
          .to( letters, {drawSVG: '100%', duration: 2, ease: 'power4.inOut', delay: -2.5} )
          .to( gold, {fill: '#D7BE67', duration: 1, ease: 'power4.inOut', delay: -1.5} )
          .to( letters, {fill: '#FEFEFE', duration: 1, ease: 'power4.inOut', delay: -1} );

      if ( window.innerWidth > 767 ) {
      // Pin sectionEighteen, control duration with the number on line 62
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: sectionEighteen,
            start: 'top top',
            pin: false,
            pinSpacing: true,
            scrub: 1,
          },
        } );
      } else {
        gsap.to( gold, {
          drawSVG: '100%',
          duration: 2,
          ease: 'power4.inOut',
          scrollTrigger: {
            trigger: logo,
            start: 'top 90%',
          },
        } );

        gsap.to( gold, {
          fill: '#D7BE67',
          duration: 1,
          ease: 'power4.inOut',
          delay: 2,
          scrollTrigger: {
            trigger: logo,
            start: 'top 90%',
          },
        } );

        gsap.to( letters, {
          drawSVG: '100%',
          duration: 1,
          ease: 'power4.inOut',
          stagger: 0.1,
          scrollTrigger: {
            trigger: logo,
            start: 'top 90%',
          },
        } );

        gsap.to( letters, {
          fill: '#FEFEFE',
          duration: 1,
          ease: 'power4.inOut',
          delay: 2,
          scrollTrigger: {
            trigger: logo,
            start: 'top 90%',
          },
        } );

        gsap.to( hdgWordsEighteen, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.inOut',
          stagger: 0.1,
          scrollTrigger: {
            trigger: sectionEighteen,
            start: 'top 50%',
          },
        } );

        gsap.to( contentEighteen, {
          y: 0,
          opacity: 1,
          duration: 2,
          ease: 'power3.inOut',
          stagger: 0.1,
          scrollTrigger: {
            trigger: sectionEighteen,
            start: 'top 25%',
          },
        } );
      }

      ScrollTrigger.create( {
        animation: eighteenAnim,
        trigger: '#section-18',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',

        end: 'top bottom',
      } );

      // NINETEEN

      const sectionNineteen = document.querySelector( '.nineteen.one-column-wysiwyg' );
      const wysiwygNineteen = sectionNineteen.querySelector( '.wysiwyg' );
      const splitWysiwygNineteen = new SplitText( wysiwygNineteen, {type: 'lines, words, chars'} );
      const wLinesNineteen = splitWysiwygNineteen.lines;
      const nineteenAnim = gsap.timeline();

      wLinesNineteen.forEach( ( line, idx ) => {
        line.classList.add( 'line' );
        const splitLine = new SplitText( line, {type: 'words'} );
        const words = splitLine.words;

        nineteenAnim.to( $( '.nineteen .line' ), {
          y: '0',
          opacity: 1,
          ease: 'power3.inOut',
          color: 'white',
          duration: 0.5,
        } );
      } );

      ScrollTrigger.create( {
        animation: nineteenAnim,
        trigger: '#section-19',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',
        end: 'top bottom',
      } );

      // TWENTY

      const sectionTwenty = document.querySelector( '.twenty.epik-logo-end' );

      const logoTwenty = sectionTwenty.querySelector( '.epik-gold' );
      const goldTwenty = logoTwenty.querySelectorAll( '.cls-1' );
      const lettersTwenty = logoTwenty.querySelectorAll( '.cls-2' );
      const twentyAnim = gsap.timeline();

      twentyAnim.to( goldTwenty, {
        drawSVG: '100%',
        duration: 2,
        ease: 'power4.inOut',
      } ).to( goldTwenty, {
        fill: '#d7be67',
        duration: 1,
        delay: -1,
      } ).to( lettersTwenty, {
        drawSVG: '100%',
        duration: 1,
        stagger: 0.1,
        ease: 'power4.inOut',
        delay: -1,
      } ).to( lettersTwenty, {
        fill: '#FEFEFE',
        duration: 1,
        delay: -0.5,
      } );

      twentyAnim.play();

      gsap.to( logoTwenty, {
        rotate: 0,
        y: -window.innerHeight / 8,
        transformOrigin: 'center',
        scrollTrigger: {
          trigger: sectionTwenty,
          start: 'bottom 100%',
          end: 'bottom top',
          scrub: true,
        },
      } );

      const borderSVG = document.querySelectorAll( '.twenty .border_svg' );
      if ( borderSVG ) {
        borderSVG.forEach( ( b, idx ) => {
          const top = b.querySelector( '.top' );
          const right = b.querySelector( '.right' );
          const bottom = b.querySelector( '.bottom' );
          const left = b.querySelector( '.left' );

          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 90%',
              scrub: false,
            },
          } );

          tl.from( left, {
            drawSVG: 0,
            duration: 1.5,
            ease: 'power4.inOut',
          } ).from( top, {
            drawSVG: 0,
            duration: 1.5,
            ease: 'power4.inOut',
          } ).from( right, {
            drawSVG: 0,
            duration: 1.5,
            ease: 'power4.inOut',
            delay: -3,
          } ).from( bottom, {
            drawSVG: 0,
            duration: 1.5,
            ease: 'power4.inOut',
          } );
        } );
      }

      ScrollTrigger.create( {
        animation: twentyAnim,
        trigger: '#section-20',
        pin: true,
        pinSpacing: false,
        start: '55% bottom',
        end: 'top bottom',
      } );

      // SNAP TO IT
      const sectionsToScroll = gsap.utils.toArray( '.inner section' );

      sectionsToScroll.forEach( ( eachSection, i ) => {
        ScrollTrigger.create( {
          trigger: eachSection,
          start: '15% bottom',
          end: 'bottom 15%',
          id: 'sectionsToScroll' + i,
          onEnter: ( self ) => goToNextSection( self, i ),
          onEnterBack: ( self ) => goToPrevSection( self, i ),
        } );
      } );
      let clicked = false;
      let nextSection;
      let prevSection;

      function goToNextSection( self, i ) {
        nextSection = '#section-'+( i+2 );
        prevSection = `#section-${i}`;
        if ( self.direction === 1 ) {
          $( 'body' ).addClass( 'no-scroll' );
          $( '.icon.down' ).addClass( 'active' );

          if ( i > 0 ) {
            $( '.icon.down' ).removeClass( 'start' );
          }

          setTimeout( function() {
            $( 'body' ).removeClass( 'no-scroll' );
            $( '.icon.down' ).removeClass( 'active' );
          }, 2000 );
        }

        if ( clicked === false ) {
          const nextSectionID = `#section-${i+1}`;
          gsap.to( window, {
            scrollTo: {y: nextSectionID, autoKill: false, ease: 'Power3.easeOut'},
            duration: 1,
          } );
        }
      }

      function goToPrevSection( self, i ) {
        nextSection = '#section-'+( i+2 );
        prevSection = `#section-${i}`;
        if ( self.direction === -1 ) {
          $( 'body' ).addClass( 'no-scroll' );
          $( '.icon.up' ).addClass( 'active' );

          setTimeout( function() {
            $( 'body' ).removeClass( 'no-scroll' );
            $( '.icon.up' ).removeClass( 'active' );
          }, 1200 );
        }
        if ( clicked === false ) {
          const nextSectionID = `#section-${i+1}`;
          gsap.to( window, {
            scrollTo: {y: nextSectionID, autoKill: false, ease: 'Power3.easeOut'},
            duration: 1,
          } );
        }
      }

      function scrollToOn() {
        setTimeout( function() {
          clicked = false;
        }, 1100 );
      }

      // CLICK TO IT
      $( '.to-top' ).on( 'click', function() {
        clicked = true;
        gsap.to( window, {
          scrollTo: {y: sectionLogo, autoKill: true, ease: 'Power3.easeOut'},
          duration: 1,
        } );
        scrollToOn();
      } );

      // down arrow clickage
      $( '.icon.down' ).on( 'click', function() {
        clicked=true;
        gsap.to( window, {
          scrollTo: {y: nextSection, autoKill: true, ease: 'Power3.easeOut'},
          duration: 1,
        } );
        scrollToOn();
      } );

      // up arrow clickage
      $( '.icon.up' ).on( 'click', function() {
        clicked=true;
        gsap.to( window, {
          scrollTo: {y: prevSection, autoKill: true, ease: 'Power3.easeOut'},
          duration: 1,
        } );
        scrollToOn();
      } );

      window.history.pushState( {}, document.title, '/' );

      const pageHeight = $( document ).height();

      // Site Progress Bar JS
      const progress = document.querySelector( '.progress' );
      gsap.to( progress, {
        width: '100%',
        scrollTrigger: {
          trigger: $( '.inner' ),
          start: 'top top',
          end: '=+' + pageHeight,
          scrub: true,
          onUpdate: ( self ) => {
            if ( self.direction == -1 ) {
              gsap.to( progress, {
                skewX: 25,
              } );
            } else {
              gsap.to( progress, {
                skewX: -25,
              } );
            }
          },
        },
      } );


      // CONTACT STUFF
      // Contact Popout Toggle Animation
      const contactToggle = document.querySelector( '.contact_toggle' );
      const ctSVG = contactToggle.querySelector( '.print-lt path' );
      const ctText = contactToggle.querySelector( '.contact_text' );
      const splitCTT = new SplitText( ctText, {type: 'chars'} );

      gsap.from( ctSVG, {
        drawSVG: 0,
        duration: 5,
        ease: 'power3.inOut',
        delay: 1,
      } );


      contactToggle.addEventListener( 'mouseenter', () => {
        if ( window.innerWidth > 1367 ) {
          gsap.to( ctSVG, {
            fill: '#D7BE67',
            duration: 0.5,
          } );

          gsap.to( splitCTT.chars, {
            opacity: 1,
            y: 0,
            duration: 0.5,
            ease: 'power3.inOut',
            // stagger: 0.1,
          } );
        }
      } );

      contactToggle.addEventListener( 'mouseleave', () => {
        if ( window.innerWidth > 1367 ) {
          gsap.to( ctSVG, {
            fill: 'transparent',
            duration: 0.5,
          } );

          gsap.to( splitCTT.chars, {
            opacity: 0,
            y: 10,
            duration: 0.5,
            ease: 'power3.inOut',
            // stagger: 0.1,
          } );
        }
      } );

      // Contact Form Animation
      const contactOverlay = document.querySelector( '.contact_form_overlay' );
      const contactFormWrap = document.querySelector( '.contact_form_wrapper' );
      const sections = document.querySelectorAll( 'section' );
      const wrapClose = contactFormWrap.querySelector( '.icon-right-arrow' );

      const checkContactMenu = () => {
        if ( !contactFormWrap.classList.contains( 'is-open' ) ) {
          contactFormWrap.classList.add( 'is-open' );
          document.body.classList.add( 'no-scroll' );

          gsap.to( sections, {
            filter: 'blur(10px)',
            duration: 2,
            ease: 'power3.inOut',
          } );

          gsap.to( contactOverlay, {
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            duration: 2,
            ease: 'power3.inOut',
          } );

          gsap.to( contactFormWrap, {
            x: 0,
            duration: 1.5,
            ease: 'power3.inOut',
            // delay: 0.5,
          } );
        } else {
          contactFormWrap.classList.remove( 'is-open' );
          document.body.classList.remove( 'no-scroll' );

          gsap.to( contactOverlay, {
            clipPath: 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)',
            duration: 2,
            ease: 'power3.inOut',
            // delay: 0.5,
          } );

          gsap.to( contactFormWrap, {
            x: '101%',
            duration: 1.5,
            ease: 'power3.inOut',
          } );

          gsap.to( sections, {
            filter: 'blur(0px)',
            duration: 2,
            ease: 'power3.inOut',
          } );
        }
      };

      contactToggle.addEventListener( 'click', () => {
        checkContactMenu();
      } );

      wrapClose.addEventListener( 'click', () => {
        checkContactMenu();
      } );

      // Contact Overlay Animation
      const contactOverlayLogo = contactOverlay.querySelector( '.epik-gold' );

      gsap.to( contactOverlayLogo, {
        rotate: -360,
        transformOrigin: 'center',
        duration: 60,
        ease: 'linear',
        repeat: -1,
      } );

      window.addEventListener( 'click', ( event ) => {
        if ( contactOverlay == event.target || contactOverlayLogo == event.target ) {
          checkContactMenu();
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
